var _path, _path2, _path3, _path4, _path5, _ellipse, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinach(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 76,
    viewBox: "0 0 81 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.542 44.553C62.0733 55.0131 51.2297 60.0297 44.3221 55.7579C37.4144 51.4861 37.0586 39.5436 43.5274 29.0835C49.9961 18.6234 60.8397 13.6068 67.7473 17.8786C71.246 20.0422 67.6456 25.822 67.7473 30.7319C67.8464 35.516 71.7344 39.3908 68.542 44.553Z",
    fill: "#7DBE81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2428 25.9613L38.0167 69.1492",
    stroke: "#3B593D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6882 26.5516L58.5016 34.0697",
    stroke: "#3B593D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.688 32.8512L50.7127 47.7679",
    stroke: "#3B593D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9331 40.0251L54.1297 41.398",
    stroke: "#3B593D"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.2242,
    cy: 35.6987,
    rx: 14.7058,
    ry: 22.2688,
    transform: "rotate(-5.14188 35.2242 35.6987)",
    fill: "#96CD82"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1888 21.1592L39.6569 70.8749",
    stroke: "#3B593D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9922 28.1498L35.9322 37.548",
    stroke: "#3B593D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4285 25.0417L35.3495 31.7399",
    stroke: "#3B593D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4225 41.3063L37.0701 47.0487",
    stroke: "#3B593D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1544 39.2554L37.2469 49.9815",
    stroke: "#3B593D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8692 19.2113C61.25 20.122 59.8819 20.426 58.424 21.4434C57.9084 21.8031 57.887 23.0805 57.2268 23.3565C54.6997 24.4131 52.2333 24.2703 51.7179 23.0375C51.2025 21.8048 52.8333 19.9489 55.3603 18.8923C57.8874 17.8357 60.3538 17.9786 60.8692 19.2113Z",
    fill: "#C87749"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinach);
export default __webpack_public_path__ + "static/media/spinach.2795e5aad815044a64ad80329c3ec275.svg";
export { ForwardRef as ReactComponent };